import { render, staticRenderFns } from "./SettingsTextAlign.vue?vue&type=template&id=7cf4a075&"
import script from "./SettingsTextAlign.vue?vue&type=script&lang=js&"
export * from "./SettingsTextAlign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports